// ضغط الصورة إلى JPEG data-url بحجم أقل من maxKB
export const compressImage = (file, maxKB = 300) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = () => reject(new Error("تعذّر قراءة الصورة"));
  reader.onload = () => {
    const img = new Image();
    img.onerror = () => reject(new Error("صورة غير صالحة"));
    img.onload = () => {
      let { width, height } = img;
      const s = Math.min(1, 1400 / Math.max(width, height));
      width = Math.round(width * s); height = Math.round(height * s);
      const canvas = document.createElement("canvas");
      const sizeKB = (u) => (u.length * 3) / 4 / 1024;
      let out = "";
      for (let i = 0; i < 6; i++) {
        canvas.width = width; canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        out = canvas.toDataURL("image/jpeg", 0.75);
        if (sizeKB(out) <= maxKB) return resolve(out);
        width = Math.round(width * 0.8); height = Math.round(height * 0.8);
      }
      reject(new Error("تعذّر ضغط الصورة — اختر صورة أصغر"));
    };
    img.src = reader.result;
  };
  reader.readAsDataURL(file);
});

export const readAsDataUrl = (file) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(r.result);
  r.onerror = () => reject(new Error("تعذّر قراءة الملف"));
  r.readAsDataURL(file);
});
